import { render } from "./TemplateCard.vue?vue&type=template&id=184f003c&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=js"
export * from "./TemplateCard.vue?vue&type=script&lang=js"

import "./TemplateCard.vue?vue&type=style&index=0&id=184f003c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184f003c"]])

export default __exports__